export default __webpack_public_path__ + "static/media/wallet08.63a5f764.png";